import React, { ReactNode } from 'react';
import { Box } from '../Rebass';
import { theme } from '../..';
import Heading from '../Heading';

interface ContactProps {
  email?: ReactNode;
  telephone?: ReactNode;
  color?: string;
  children?: ReactNode;
}

const Contact = ({
  email,
  telephone,
  color = theme.colors.baseBlack,
  children,
}: ContactProps) => {
  return (
    <Box>
      <Box mb={[2]}>
        {email && (
          <Heading mb={[1]} size="h4" fontWeight="normal" color={color}>
            {email}
          </Heading>
        )}
        {telephone && (
          <Heading mb={[1]} size="h4" fontWeight="normal" color={color}>
            {telephone}
          </Heading>
        )}
      </Box>
      {children}
    </Box>
  );
};

export default Contact;
